import { LocationSurcharge } from "./location-surcharge.type";
import { FclLocationSurcharge } from "./location-surcharge-fcl.model";
import { containerLoad } from "../../shared/container/load-types.const";
import { LclLocationSurcharge } from "./location-surcharge-lcl.model";
import { QuoteLocationSurchargeMapper } from "../../quote/quote-surcharge/quote-location-surcharge.mapper";
import { CarrierMapper } from "../../carrier/carrier.mapper";
import { ContainerPrices } from "../../shared/container/container-prices.model";
import { AirLocationSurcharge } from "./location-surcharge-air.model";
import { LtlLocationSurcharge } from "./location-surcharge-ltl.model";
import { SurchargeTypeMapper } from "app/surcharge-type/surcharge-type.mapper";

export class LocationSurchargeMapper {
  private static parsePrice(value: any): number {
    if (typeof value === "string") {
      value = value.replace(",", ".");
    }
    return parseFloat(value) || 0;
  }

  public static map(data: any): LocationSurcharge {
    if (!data) {
      return null;
    }

    if (!data.discriminator) {
      console.error("no discriminator");

      return null;
    }

    if (data.discriminator === containerLoad.fcl) {
      return new FclLocationSurcharge(
        data.id,
        data.discriminator,
        data.name,
        CarrierMapper.map(data.carrier),
        data.type,
        new ContainerPrices(data.containers),
        data.shipmentPrice,
        data.assignment,
        Array.isArray(data.quoteLocationSurcharges)
          ? data.quoteLocationSurcharges.map(QuoteLocationSurchargeMapper.map)
          : [],
        data.currency,
        SurchargeTypeMapper.map(data.surchargeType),
        data.debugInfo,
        data.chargedFor,
        data.internalNote,
        data.restrictedNote,
        data.availableOnline,
        data.sort,
      );
    }

    if (data.discriminator === containerLoad.lcl) {
      return new LclLocationSurcharge(
        data.id,
        data.discriminator,
        data.name,
        CarrierMapper.map(data.carrier),
        data.type,
        LocationSurchargeMapper.parsePrice(data.weightPrice),
        LocationSurchargeMapper.parsePrice(data.measurementPrice),
        LocationSurchargeMapper.parsePrice(data.shipmentPrice),
        LocationSurchargeMapper.parsePrice(data.piecePrice),
        LocationSurchargeMapper.parsePrice(data.documentPrice),
        LocationSurchargeMapper.parsePrice(data.minPrice),
        LocationSurchargeMapper.parsePrice(data.maxPrice),
        data.assignment,
        Array.isArray(data.quoteLocationSurcharges)
          ? data.quoteLocationSurcharges.map(QuoteLocationSurchargeMapper.map)
          : [],
        data.currency,
        SurchargeTypeMapper.map(data.surchargeType),
        data.debugInfo,
        data.chargedFor,
        data.internalNote,
        data.availableOnline,
        data.sort,
      );
    }

    if (data.discriminator === containerLoad.air) {
      return new AirLocationSurcharge(
        data.id,
        data.discriminator,
        data.name,
        CarrierMapper.map(data.carrier),
        data.type,
        LocationSurchargeMapper.parsePrice(data.weightPrice),
        LocationSurchargeMapper.parsePrice(data.chargeableWeightPrice),
        LocationSurchargeMapper.parsePrice(data.measurementPrice),
        LocationSurchargeMapper.parsePrice(data.shipmentPrice),
        LocationSurchargeMapper.parsePrice(data.piecePrice),
        LocationSurchargeMapper.parsePrice(data.documentPrice),
        LocationSurchargeMapper.parsePrice(data.minPrice),
        LocationSurchargeMapper.parsePrice(data.maxPrice),
        data.assignment,
        Array.isArray(data.quoteLocationSurcharges)
          ? data.quoteLocationSurcharges.map(QuoteLocationSurchargeMapper.map)
          : [],
        data.currency,
        SurchargeTypeMapper.map(data.surchargeType),
        data.debugInfo,
        data.chargedFor,
        data.internalNote,
        data.availableOnline,
        data.sort,
      );
    }

    if (data.discriminator === containerLoad.ltl) {
      return new LtlLocationSurcharge(
        data.id,
        data.discriminator,
        data.name,
        CarrierMapper.map(data.carrier),
        data.type,
        LocationSurchargeMapper.parsePrice(data.shipmentPrice),
        LocationSurchargeMapper.parsePrice(data.pricePer100Kg),
        LocationSurchargeMapper.parsePrice(data.pricePerPiece),
        LocationSurchargeMapper.parsePrice(data.pricePerPallet),
        data.assignment,
        Array.isArray(data.quoteLocationSurcharges)
          ? data.quoteLocationSurcharges.map(QuoteLocationSurchargeMapper.map)
          : [],
        data.currency,
        SurchargeTypeMapper.map(data.surchargeType),
        data.debugInfo,
        data.chargedFor,
        data.internalNote,
        data.sort,
      );
    }
  }
}
